import type { Shipment } from './types.ts';
/** Active exceptions and journeys first; within each queue the newest pickup leads. */
export function shipmentOrder(a: Shipment, b: Shipment) {
  const rank = { attention: 0, in_transit: 0, delivered: 1, planned: 2 };
  return rank[a.status] - rank[b.status] || b.plannedDepartureAt - a.plannedDepartureAt;
}
